import ModelViewer from './ModelViewer'

const style = String.raw`
	<style>
		h4 {
			--color1: hsl(35.63deg 31.68% 60.39%);
			--color2: hsl(35.63deg 31.68% 25%);

			position: absolute;
			top: 2%;
			left: 50%;
			transform: translateX(-50%);
			z-index: 1000;

			font-size: 1vmax;
			font-weight: 100;
			pointer-events: none;

			background: linear-gradient(90deg, var(--color1), var(--color2), var(--color2), var(--color1));
			background-size: 400%;
			background-clip: text;
			color: transparent;
			animation: AnimateBG 10s linear infinite;
			transition: opacity .5s;
			opacity: 0;
		}

		h4.Titanium {
			--color1: #b3b3b3;
    		--color2: #595959;
		}

		h4.visible {
			opacity: 1
		}

		@keyframes AnimateBG {
			0% { background-position-x: 400% }
			100% { background-position-x: 00% }
		}

	</style>
`

export class LoadingIndicator {
	viewer: ModelViewer
	header: HTMLHeadingElement

	constructor(viewer: ModelViewer) {
		this.viewer = viewer
		this.viewer.shadowRoot.append(parseHTML(style))
		this.header = document.createElement('h4')
		this.header.innerText = 'loading'
		this.viewer.shadowRoot.append(this.header)
	}
	show() {
		this.header.className = this.viewer.theme
		this.header.classList.add('visible')
	}

	hide() {
		this.header.classList.remove('visible')
	}
}

function parseHTML(html) {
	var t = document.createElement('template')
	t.innerHTML = html
	return t.content
}
